module.exports = "/lucky-balls/img/kvacica.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/kvacica.png
// module id = 100
// module chunks = 0